import { createSelector } from '@ngrx/store';
import * as fromPaymentsReducer from '../reducers';
import * as fromPaymentRunsReducer from '../reducers/payment-run.reducer';

export const selectAllPaymentRuns = createSelector(fromPaymentsReducer.selectPaymentRunsEntitiesState, fromPaymentRunsReducer.selectAll);

export const selectPaymentRunsLoaded = createSelector(fromPaymentsReducer.selectPaymentRunsEntitiesState, state => state.loaded);

export const selectPaymentRunsLinks = createSelector(fromPaymentsReducer.selectPaymentRunsEntitiesState, state => state.links);

export const selectPaymentRunsMeta = createSelector(fromPaymentsReducer.selectPaymentRunsEntitiesState, state => state.meta);

export const selectPaymentRunsError = createSelector(fromPaymentsReducer.selectPaymentRunsEntitiesState, state => state.error);

export const selectPaymentRunsTotalItems = createSelector(selectPaymentRunsMeta, state => state.totalItems);
export const selectPaymentRunsItemCount = createSelector(selectPaymentRunsMeta, state => state.itemCount);
export const selectPaymentRunsItemsPerPage = createSelector(selectPaymentRunsMeta, state => state.itemsPerPage);
export const selectPaymentRunsCurrentPage = createSelector(selectPaymentRunsMeta, state => state.currentPage);
